const scrollPage = () => {
  let domTarget = document.querySelector(".theme-product-reviews");
  if (domTarget) {
    domTarget.addEventListener("click", function () {
      const targetElement = document.querySelector(".okeReviews.oke-w");
      if (targetElement) {
        var targetPosition =
          targetElement.getBoundingClientRect().top + window.pageYOffset - 150;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  }
};

// 去掉导航栏logo
const RemoveNavBarLogo = () => {
  const mainNav = document.querySelector("#main-nav");
  if (mainNav) {
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === "childList") {
          let watermarkElements = mainNav.querySelectorAll(
            ".tmenu-watermark.tmenu_item_link"
          );
          watermarkElements.forEach(function (element) {
            if (element.style.display === "flex") {
              element.style.display = "none";
            }
          });
        }
      });
    });

    observer.observe(mainNav, {
      childList: true,
      subtree: true,
    });
  }
};

// 在移动端打开搜索框
const handleSearchPlugInIsShow = () => {
  const searchButton = document.querySelector(".oasislamp-mobile-show-search");
  const searchElement = document.querySelector(
    "._container_z49kb_1._fixedPosition_z49kb_12.rps-csb-container-new"
  );
  const headerElement = document.querySelector(
    ".shopify-section.shopify-section-group-header-group.section-header"
  );
  const showIcon = searchButton.querySelector(".show-search-link__icon");
  const closeIcon = searchButton.querySelector(".close-search-link__icon");

  if (searchElement && headerElement) {
    document.documentElement.style.setProperty(
      "--rps-csb-search-bar-height",
      "58.60000228881836px"
    );
    searchElement.style.display = "none"; // 隐藏
    closeIcon.style.display = "none"; // 隐藏
    headerElement.classList.remove("rps-csb-margin-bottom"); // 去掉类名
  }
  searchButton.addEventListener("click", (e) => {
    if (
      searchElement.style.display === "none" ||
      searchElement.style.display === ""
    ) {
      showIcon.style.display = "none"; // 隐藏
      closeIcon.style.display = "inline"; // 隐藏
      searchElement.style.display = "block"; // 显示
      searchElement.style.zIndex = 99;
      // headerElement.classList.add("rps-csb-margin-bottom"); // 添加类名
      headerElement.setAttribute(
        "style",
        "margin-bottom: 58.60000228881836px !important;"
      );
    } else {
      showIcon.style.display = "inline"; // 隐藏
      closeIcon.style.display = "none"; // 隐藏
      searchElement.style.display = "none"; // 隐藏
      // headerElement.classList.remove("rps-csb-margin-bottom"); // 去掉类名
      headerElement.setAttribute("style", "margin-bottom: 0px !important;");
    }
  });
};

document.addEventListener("DOMContentLoaded", function () {
  scrollPage();
  RemoveNavBarLogo();

  if (window.matchMedia("(max-width: 768px)").matches) {
    handleSearchPlugInIsShow();
  }
});
